export enum EventDimension {
  START = 1,
  END = 8
}
